import SingleDoctor from '../pages/Doctors/SingleDoctor.vue'
import SingleClinic from '../pages/Clinics/SingleClinic.vue'

import DoctorPage from '../pages/DoctorPage.vue'
import Agenda from '../pages/Agenda.vue'
import Search from '../pages/Search.vue'

/**
 * Router map
 */

export default [{
	path: '/',
	component: require('../pages/Root.vue'),
	children: [{
		name: 'Main',
		path: '/',
		component: require('../pages/General.vue'),
	}, {
		name: 'Clinics',
		path: 'clinics',
		component: require('../pages/Clinics/Clinics.vue'),
	}, {
		name: 'Doctors',
		path: 'doctors',
		component: require('../pages/Doctors/Doctors.vue'),
	}, {
		name: 'Cabinet',
		path: 'cabinet/:id',
		component: require('../pages/Cabinet/Cabinet.vue'),
		children: [{
			name: 'Own',
			path: 'own',
			component: require('../pages/Cabinet/Cabinet/Main.vue'),
			children: [{
				name: 'Events',
				path: 'events',
				component: require('../pages/Cabinet/Cabinet/Tabs/Events.vue'),
			}, {
				name: 'Visits',
				path: 'visits',
				component: require('../pages/Cabinet/Cabinet/Tabs/Visits.vue'),
			}],
		}, {
			name: 'Message',
			path: 'message',
			component: require('../pages/Cabinet/Message/Message.vue'),
		}, {
			name: 'Card',
			path: 'card',
			component: require('../pages/Cabinet/Card/Card.vue'),
			children: [{
				path: '/',
			}],
		}, {
			name: 'Nurse',
			path: 'nurse',
			component: require('../pages/Cabinet/Nurse/Nurse.vue'),
		}, {
			name: 'Clinic',
			path: 'clinic/:clinic',
			component: require('../pages/Cabinet/Clinic/Main.vue'),
			children: [
				{
					name: 'Profile',
					path: 'profile/:profile',
					component: require('../pages/Cabinet/Clinic/Tabs/Profile.vue'),
				},
				{
					name: 'Personal',
					path: 'personal',
					component: require('../pages/Cabinet/Clinic/Tabs/Personal.vue'),
				},
				{
					name: 'Patients',
					path: 'patients',
					component: require('../pages/Cabinet/Clinic/Tabs/Patients.vue'),
				},
				{
					name: 'ClinicVisits',
					path: 'visits',
					component: require('../pages/Cabinet/Clinic/Tabs/Visits.vue'),
				},
			],
		}, {
			name: 'Registry',
			path: 'registry/:clinic',
			component: require('../pages/Cabinet/Registry/Registry.vue'),
		}, {
			name: 'GeneralSchedule',
			path: 'general_schedule/:clinic',
			component: require('../pages/Cabinet/GeneralSchedue/GeneralSchedule.vue'),
		}],
	}, {
		name: 'SingleDoctor',
		path: 'doctor',
		component: SingleDoctor,
	}, {
		name: 'SingleClinic',
		path: 'clinic',
		component: SingleClinic,
	}, {
		path: 'doctor_page',
		component: DoctorPage,
	}, {
		name: 'Agenda',
		path: 'agenda',
		component: Agenda,
	}, {
		name: 'Search',
		path: 'search',
		component: Search,
	}, {
		name: 'Setting',
		path: 'setting',
		component: require('../pages/Setting.vue'),
	}],
}, {
	name: 'Login',
	path: '/login',
	component: require('../components/App/Login.vue'),
}, {
	path: '/register',
	component: require('../components/App/Register.vue'),
	children: [{
		name: 'One',
		path: '/',
		component: require('../components/App/Register/One.vue'),
	}, {
		name: 'Two',
		path: 'second_step',
		component: require('../components/App/Register/Two.vue'),
	}, {
		name: 'Three',
		path: 'third_step',
		component: require('../components/App/Register/Three.vue'),
	}, {
		name: 'Four',
		path: 'fourth_step',
		component: require('../components/App/Register/Four.vue'),
	}],
}, {
	path: '/admin_panel',
	component: require('../pages/Admin panel/Admin panel.vue'),
}, {
	path: '/agreement',
	name: 'Agreement',
	component: require('../components/Agreement.vue'),
}, {
	path: '/offer',
	name: 'Offer',
	component: require('../components/Offer.vue'),
}]



// WEBPACK FOOTER //
// ./src/router/routes.js